import * as React from "react";

export interface CheckoutArrowIconProps extends React.SVGProps<SVGSVGElement> {
    direction?: "left" | "right";
}

const CheckoutArrowLeftIcon: React.FC<CheckoutArrowIconProps> = ({ direction = "left", ...props }) => {
    return (
        <svg
            {...props}
            width="21"
            height="8"
            viewBox="0 0 21 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            focusable="false"
        >
            <g transform={direction === "right" ? "translate(21 0) scale(-1 1)" : undefined}>
                <path
                    d="M20.5 4.18198C20.7761 4.18198 21 3.95812 21 3.68198C21 3.40584 20.7761 3.18198 20.5 3.18198L20.5 3.68198L20.5 4.18198ZM0.146446 3.32842C-0.0488148 3.52369 -0.0488148 3.84027 0.146446 4.03553L3.32843 7.21751C3.52369 7.41277 3.84027 7.41277 4.03553 7.21751C4.2308 7.02225 4.2308 6.70567 4.03553 6.51041L1.20711 3.68198L4.03553 0.853552C4.2308 0.658289 4.2308 0.341707 4.03553 0.146445C3.84027 -0.0488174 3.52369 -0.0488174 3.32843 0.146445L0.146446 3.32842ZM20.5 3.68198L20.5 3.18198L0.5 3.18198L0.5 3.68198L0.5 4.18198L20.5 4.18198L20.5 3.68198Z"
                    fill="currentColor"
                />
            </g>
        </svg>
    );
};

export default React.memo(CheckoutArrowLeftIcon);